// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__24qlQ","gnr":"Card_gnr__7JnYD","link":"Card_link__3hxSY"};